export const LOCAL_STORAGE_USER_KEY = 'facit_authUsername';

export const LOCAL_STORAGE_TOKEN_KEY = '__token';

export const BASE_URL = 'https://gmw.megawattlucegas.it:8080/';
// export const BASE_URL = 'http://localhost:8080/';

export const DEFAULT_TIMEOUT_REQUESTS = 30000;

export const DEFAULT_ITEMS_FOR_PAGE = 10;

export const INITIAL_PAGE_NUMBER = 0;

export const PUBLIC = '__public';

export const FORNITORI = [
	'A2A Energia',
	'A2A ENERGIA',
	'Abenergies',
	'Acea Energia',
	'Acegas',
	'Acel Energie',
	'AGN ENERGIA',
	'Agsm Energia',
	'Aim Energy',
	'Ajò Energia',
	'Alegas',
	'Alperia Energia',
	'Ape Energia',
	'Ariel Energia',
	'Audax',
	'Autogas Nord',
	'Barocco Energia',
	'Blue Meta',
	'Bluenergy',
	'Cogeser Energia',
	'Colsam Energie',
	'Coop Luce e Gas',
	'Dolomiti Energia',
	'E.ON',
	'ECOM',
	'Edison Energia',
	'Enel Energia',
	'Energetic s.p.a.',
	'Energia Azzurra',
	'ENERGIA SOSTENIBILE',
	'ENERGIA VERDE ITALIA',
	'Energygas Italia',
	'Enerxenia',
	'Engie Italia',
	'Eni Plenitude',
	'ENJOY ENERGY',
	'Enne Energia',
	'Estra Energie',
	'Eviva',
	'Evolvere',
	'Facile.Energy',
	'FuturEnergy Rinnovabile',
	'Gala',
	'Gesam Gas e Luce',
	'Green Network',
	'Hera Comm',
	'Iberdrola',
	'Illumia',
	'Iren',
	'Italia Gas e Luce',
	'Levigas',
	'Meta Energia',
	'Metano Nord',
	'Nen',
	'New Energy Gas e Luce',
	'NoiEnergia',
	'Omnia Energia',
	'Omnia24',
	'Optima Energia',
	'OV Energy',
	'PICCHIO GAS',
	'PLT Puregreen',
	'POD Attivo',
	'POSTEPAY',
	'Pulsee Luce e Gas',
	'REC ENERGY',
	'Repower',
	'Senec',
	'Servizio elettrico Roma',
	'SERVIZIO ENERGETICO ITALIANO',
	'Sicme Energy e Gas',
	'Sienergia',
	'SIMECOM',
	'Sinergy',
	'SMART ENERGY',
	'Sorgenia',
	'Spigas',
	'Switch luce & Gas',
	'Tate Energia',
	'Tea Energia',
	'Unogas Gas, Luce e Servizi',
	'Vivigas',
	'Wekiwi Energia',
];

export const TOPONOMASTICA = [
	'BORGO',
	'CAMPO',
	'CASA',
	'CONTRADA',
	'CORSO',
	'FRAZIONE',
	'LARGO',
	'LOCALITA',
	'PASSO',
	'PIAZZA',
	'PIAZZALE',
	'RAMPA',
	'SALITA',
	'TRONCO',
	'VIA',
	'VIALE',
	'VICO',
	'VICOLO',
	'VILLA',
];
export const TYPE_CONTRACT = [
	{ power: 'Power Business', type: 'Teleselling Mega Business Luce' },
	{ power: 'Power Domestico', type: 'Mega Dinamico Pun Teleselling' },
	{ power: 'Power Domestico', type: 'Mega Dinamico Pun DtoD' },
	{ power: 'Power Business', type: 'DTOD Mega Business Luce' },
	{ power: 'Power DIP', type: 'Mega Dinamico DIPENDENTI' },
	{ power: 'Gas Business', type: 'Teleselling BMega Gas' },
	{ power: 'Gas Business', type: 'DtoD BMega Gas' },
	{ power: 'Gas DIP', type: 'Mega Gas DIPENDENTI' },
	{ power: 'Gas Domestico', type: 'DTOD MEGA GAS' },
	{ power: 'Gas Domestico', type: 'Teleselling Mega Gas' },
	{ power: 'Power Condominio', type: 'Mega Condominio Luce' },
	{ power: 'Power CRAL', type: 'Mega amico Cral Tlc' },
	{ power: 'Gas CRAL', type: 'Mega Gas Cral' },
];

export const DOCUMENT_OPTIONS = [
	{ value: 'cartaIdentita', label: "Carta d'Identità" },
	{ value: 'passaporto', label: 'Passaporto' },
	{ value: 'patente', label: 'Patente' },
];
